var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/feature/connections/PLUpsell/PLUpsellTemplate.jsx";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import marked from 'marked';
import styled from 'styled-components';
import { Button, Heading, Text, Tag, Spacer } from '@zillow/constellation';
import PLUpsell from './PLUpsell';
import OmpIcon from '../../../internal/DisplayIcon/OmpIcon';
var StyledBody = styled.div.withConfig({
  displayName: "PLUpsellTemplate__StyledBody",
  componentId: "sc-62rgip-0"
})(["padding:0 10px 10px 0;display:block;"]);
var StyledTag = styled(Tag).withConfig({
  displayName: "PLUpsellTemplate__StyledTag",
  componentId: "sc-62rgip-1"
})(["background:none;position:absolute;max-width:220px;height:14px;top:8px;right:8px;text-align:right;"]);
var PLUpsellTemplate = styled(function (_ref) {
  var actionLink = _ref.actionLink,
      actionText = _ref.actionText,
      actionType = _ref.actionType,
      background = _ref.background,
      bodyMarkdownText = _ref.bodyMarkdownText,
      headingMarkdownText = _ref.headingMarkdownText,
      icon = _ref.icon,
      iconFontColor = _ref.iconFontColor,
      media = _ref.media,
      onClickUpsellButton = _ref.onClickUpsellButton,
      onHoverCTA = _ref.onHoverCTA,
      overrideMargin = _ref.overrideMargin,
      additionalProps = _ref.additionalProps,
      gaLocation = _ref.gaLocation,
      gaSurface = _ref.gaSurface,
      gaTreatment = _ref.gaTreatment,
      showAdvertisement = _ref.showAdvertisement,
      tagInput = _ref.tagInput,
      trackingParameter = _ref.trackingParameter,
      restProps = _objectWithoutProperties(_ref, ["actionLink", "actionText", "actionType", "background", "bodyMarkdownText", "headingMarkdownText", "icon", "iconFontColor", "media", "onClickUpsellButton", "onHoverCTA", "overrideMargin", "additionalProps", "gaLocation", "gaSurface", "gaTreatment", "showAdvertisement", "tagInput", "trackingParameter"]);

  var headingNode = function headingNode() {
    if (headingMarkdownText && showAdvertisement) {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 50,
          columnNumber: 21
        }
      }, /*#__PURE__*/React.createElement(Spacer, {
        paddingBottom: "xs",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 51,
          columnNumber: 25
        }
      }, /*#__PURE__*/React.createElement(StyledTag, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 52,
          columnNumber: 29
        }
      }, tagInput)), /*#__PURE__*/React.createElement(Heading, {
        level: 6,
        dangerouslySetInnerHTML: {
          __html: marked.parseInline(headingMarkdownText)
        },
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 54,
          columnNumber: 25
        }
      }));
    }

    if (headingMarkdownText) {
      return /*#__PURE__*/React.createElement(Heading, {
        level: 6,
        dangerouslySetInnerHTML: {
          __html: marked.parseInline(headingMarkdownText)
        },
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 65,
          columnNumber: 21
        }
      });
    }

    if (showAdvertisement) {
      return /*#__PURE__*/React.createElement(Spacer, {
        paddingBottom: "xs",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 75,
          columnNumber: 21
        }
      }, /*#__PURE__*/React.createElement(StyledTag, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 76,
          columnNumber: 25
        }
      }, tagInput));
    }

    return null;
  };

  var bodyNode = bodyMarkdownText ? /*#__PURE__*/React.createElement(StyledBody, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Text, {
    dangerouslySetInnerHTML: {
      __html: marked.parseInline(bodyMarkdownText)
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 17
    }
  })) : null;
  var actionButton = actionText ? /*#__PURE__*/React.createElement(Button, {
    onClick: onClickUpsellButton,
    onMouseEnter: onHoverCTA,
    "data-actiontype": actionType,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 93,
      columnNumber: 13
    }
  }, actionText) : null;
  var ompIcon = /*#__PURE__*/React.createElement(OmpIcon, {
    icon: icon,
    iconFontColor: iconFontColor,
    imageAlt: media === null || media === void 0 ? void 0 : media.alt,
    imageSrc: media === null || media === void 0 ? void 0 : media.src,
    imageSize: "lg",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 13
    }
  });
  return /*#__PURE__*/React.createElement(PLUpsell, _extends({
    background: background,
    heading: headingNode(),
    body: bodyNode,
    actionButton: actionButton,
    media: ompIcon,
    showModal: !actionLink || actionLink === '',
    overrideMargin: overrideMargin,
    additionalProps: additionalProps,
    gaSurface: gaSurface,
    gaLocation: gaLocation,
    gaTreatment: gaTreatment,
    showAdvertisement: showAdvertisement,
    tagInput: tagInput,
    trackingParameter: trackingParameter
  }, restProps, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 13
    }
  }));
}).withConfig({
  displayName: "PLUpsellTemplate",
  componentId: "sc-62rgip-2"
})([""]);
PLUpsellTemplate.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The action link, optional.
   * The PL Upsell will show a Partner lead submit modal if action link is empty
   */
  actionLink: PropTypes.string,

  /**
   * The action text displayed in component.
   * */
  actionText: PropTypes.string,

  /**
   * The action type that helps determine the onAction function.
   * */
  actionType: PropTypes.string,

  /**
   * The background color displayed in component.
   * */
  background: PropTypes.oneOf(['backgroundBlue', 'backgroundWhite']),

  /**
   * The message body displayed in component.
   * */
  bodyMarkdownText: PropTypes.string,

  /**
   * The message head displayed in component.
   * */
  headingMarkdownText: PropTypes.string,

  /**
   * Icon used in your messaging. Currently 'dollar', 'home', 'logo', 'phone',
   * 'salesign', 'pigggy', 'ZOHome', 'houseWithDollarSign', 'hangingSign',
   * 'testimonialIcon', 'hourglassIcon', 'moneyIcon', 'heartHome', 'comparableHome',
   * 'appHome' & 'calendar' are valid.
   * Default icon is a zillow logo.
   * */
  icon: PropTypes.string,

  /**
   * The constellation color code for the icon's drawing color.
   * Available constellation color codes could be found at
   * http://constellation.pages.zgtools.net/constellation-site/constellation-api.html#section-colors
   */
  iconFontColor: PropTypes.string,
  media: PropTypes.shape({
    /**
     * The alt text of the image.
     */
    alt: PropTypes.string,

    /**
     * The url of the image. This is used as an alternative to icon.
     */
    src: PropTypes.string
  }),
  onClickUpsellButton: PropTypes.func,
  onHoverCTA: PropTypes.func,
  additionalProps: PropTypes.shape({
    property: PropTypes.object,
    viewer: PropTypes.object,
    abadClient: PropTypes.func,
    zatlasEndpoint: PropTypes.string,
    shouldShowcheckBox: PropTypes.bool
  }),

  /**
   * The margin value to adjust spacing around the upsell UI.
   * Enter value in the format: top right bottom left
   * Default value: 0px 16px 0px 16px
   */
  overrideMargin: PropTypes.string,
  gaSurface: PropTypes.string,
  gaLocation: PropTypes.string,
  gaTreatment: PropTypes.string,

  /**
   * When true, the text within `tagInput` prop will render top right on
   * the component.
   * Default value is false.
   */
  showAdvertisement: PropTypes.bool,

  /**
   * This text will populate in the top right corner of the component.
   * The `showAdvertisement` must be set to true for this to appear. Currently
   * this is set to false by default.
   * Default value is currently 'ADVERTISEMENT'
   */
  tagInput: PropTypes.string
} : {};
PLUpsellTemplate.defaultProps = {
  actionLink: null,
  actionText: 'Click',
  actionType: null,
  background: 'backgroundBlue',
  bodyMarkdownText: null,
  headingMarkdownText: null,
  icon: null,
  iconFontColor: '',
  media: {
    alt: '',
    src: ''
  },
  onClickUpsellButton: function onClickUpsellButton() {},
  onHoverCTA: function onHoverCTA() {},
  overrideMargin: '16px 16px 16px 16px',
  additionalProps: {},
  gaSurface: null,
  gaLocation: null,
  gaTreatment: null,
  showAdvertisement: false,
  tagInput: 'ADVERTISEMENT',
  trackingParameter: ''
};
/** @component styled-guidist */

export default PLUpsellTemplate;